import { Button } from "primereact/button";
import ProductCardWrapper from "./ProductCard.style";
import { withTranslation } from "react-i18next";
import { t } from "i18next";
import { RadioButton } from "primereact/radiobutton";
import { useSelector } from "react-redux";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../../helpers/utils";

const ProductCard = (props) => {
  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <ProductCardWrapper>
      <div
        className={
          "check-card p-0 " + (props.i18n.language === "ar" ? "ar" : "")
        }
        onClick={() => {
          if (
            props.isHomeInsurance &&
            props.isHomeInsurance === true &&
            props.changeHomeInsurance
          ) {
            props.changeHomeInsurance(!props.isActive);
          }
          !props.disabled && props.onSelect(props.productCode);
        }}
      >
        <div className="check-card-item">
          <input
            type="checkbox"
            id={`product-check-${props.productCode}`}
            value={props.productCode}
            disabled={props.disabled}
            checked={props.isActive}
            onChange={() => props.onSelect(props.productCode)}
          />
          <div
            style={{ backgroundImage: `url(${props.bgImg || ""})` }}
            className={
              "check-card-body" +
              (props.bundleStyle ? " bundle" : "") +
              (props.disabled ? " disabled" : "") +
              (businessLine ? " check-card-body-stc" : "")
            }
          >
            <div className="check-card-body-in">
              <div>
                {props.image}
                <h3
                  className={
                    "check-card-title" +
                    (props.titleClasses ? " " + props.titleClasses : "")
                  }
                >
                  {props.title}
                </h3>
                {props.subTitle ? (
                  <p
                    className={
                      "check-card-description" +
                      (props.subTitleClasses ? " " + props.subTitleClasses : "")
                    }
                  >
                    {props.subTitle}
                  </p>
                ) : (
                  <p
                    style={{ color: props.isActive ? "white" : businessColor }}
                  >
                    +
                  </p>
                )}
                {/* <RadioButton   id={`product-check-${props.productCode}`}></RadioButton> */}
              </div>
              <div className={`${props.isActive ? "platinum-active" : ""} travel-platinum`}>{t("platinum")}</div>
              {props.limits && (
                <span>
                  {t("limits.Limit")}
                  <br />
                  {t(props.limits)}
                </span>
              )}
              {/* for price and discount */}
              <div>
                {props.price && !props.isDisabled ? (
                  <p className="check-card-price">
                    <span className="d-block check-card-sale-amount">
                      {props.salePrice ? (
                        <del>
                          <span>{t("SR")} </span>
                          {props.price.toFixed(2)}
                        </del>
                      ) : (
                        t("price")
                      )}
                    </span>
                    <span className="check-card-amount">
                      {t("SR")}{" "}
                      <span className="lato">
                        {" "}
                        {props.salePrice ? props.salePrice.toFixed(2) : props.price.toFixed(2)}
                      </span>
                    </span>
                  </p>
                ) : (
                  <p className="check-card-disable"></p>
                )}
                {!props.hideCoverageDetails && (
                  <Button
                    disabled={props.disableDetailsBtn}
                    type="button"
                    className="px-2 py-1"
                    label={props.detailsLabel || props.t("coverage-details")}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onLinkClick(e, props.productCode);
                    }}
                  />
                )}
              </div>

              {/* for sale badge */}
              {props.badge && (
                <div className="badge">
                  {props.badge}
                  <span>%</span>
                </div>
              )}
            </div>
            {props.isHomeInsurance && (
              <h4 className="home-insurance-max-limit">
                {t("HomeInsuranceMaxLimit")}
              </h4>
            )}
            {/* <h4 className="home-insurance-max-limit">
                            {limits.map(e => {
                                return `${e.data}`
                            })}
                        </h4> */}
          </div>
        </div>
      </div>
    </ProductCardWrapper>
  );
};

export default withTranslation()(ProductCard);
